module.exports = __webpack_public_path__ + "images/baseline-survey-044ad4857229727a31c21b5e58dc7be8.png";